/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/selectize/selectize.d.ts" />

namespace Application.Controllers {
    'use strict';
 
    import SimPlan = Models.SimPlan;
    import IPaginatedList = Models.IPaginatedList;

    interface ISelectOption {
        value: string;
        text: string;
    }

    /**
     * NetworkNodeController class
     */
    export class SimPlanController {
        public static $name: string = "simPlanController";
        public static $inject: string[] = ['simPlanService',
                                           'simService',
                                           'ModalService',
                                           '$timeout',
                                           '$scope',
                                           'messageTranslationsService',
                                           ];
        public simPlans: IPaginatedList<SimPlan>;

        public paginationSize: number;
        public paginationPage: number;

        private simPlanService: Services.SimPlanService;
        private simService: Services.SIMService;
        private modalService: ngModal.IModalService;
        private $timeout: ng.ITimeoutService;
        private $scope: ng.IScope;
        private messageTranslationsService: Services.MessageTranslationsService;

        private selectize: Selectize.IApi<number, ISelectOption>;

        /**
         * Constructor of the class.
         */
        constructor(simPlanService: Services.SimPlanService,
                    simService: Services.SIMService,
                    modalService: ngModal.IModalService,
                    $timeout: ng.ITimeoutService,
                    $scope: ng.IScope,
                    messageTranslationsService: Services.MessageTranslationsService ) {
            this.simPlanService = simPlanService;
            this.simService = simService;
            this.modalService = modalService;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.messageTranslationsService = messageTranslationsService;


            this.initData();
            this.loadSelectize();

            this.$scope.$on('$destroy', () => {
                if (this.selectize)
                    this.selectize.destroy();
            });
        }

        public humanReadableBytes(value: number): string {
            return Common.Utils.humanReadableBytes(value, 1);
        }

        public simPlanTypeToString(type: Models.SimPlanType): string {
            if (type === Models.SimPlanType.POSTPAID)
                return "postpaid";
            else if (type === Models.SimPlanType.PREPAID)
                return "prepaid";
            else
                return "unknown";
        }

        public launchSimPlanModal(title: string, plan: Models.SimPlan): void {
            let self: SimPlanController = this;
            let copy: Models.SimPlan = plan === undefined ? Models.SimPlan.Empty() : Models.SimPlan.Copy(plan);
            
            this.modalService.showModal({
                templateUrl: Application.Controllers.SimPlanModalController.templateURL,
                controller: Application.Controllers.SimPlanModalController.$name,
                inputs: {
                    title: title,
                    plan: copy,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.SimPlanModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.scope.loadSelectize();
                modal.close.then((result: Models.SimPlan) => {
                    modalElem.hide();
                    if (result)
                        self.saveSimPlan(result);
                });
            });
        }

        /**
         * Change the list view to another a given page.
         * @param {number} page - The page number to show
         */
        public changePageNumber(page: number): void {
            this.paginationPage = page;
            this.loadSimPlans();
        }

        public deleteSimPlanModal(plan: SimPlan): void {
            this.simService.getAllBySimPlanId(Common.Utils.idFromHref(plan.href)).then((result: Models.ISIM[]) => {
                if (result.length > 0) {
                    this.modalService.showModal({
                        templateUrl: Application.Controllers.InfoModalController.templateURL,
                        controller: Application.Controllers.InfoModalController.$name,
                        inputs: {
                            title: 'SIM plan in use',
                            description: "The current plan cannot be removed as is in use by one or multiple SIM cards",
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.InfoModalController.ID, 
                                                            {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();                           
                        modal.close.then((result2: Object) => {
                            modalElem.hide();
                        });
                    });
                } else {
                    let self: SimPlanController = this;
                    this.modalService.showModal({
                        templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                        controller: Application.Controllers.ConfirmModalController.$name,
                        inputs: {
                            title: 'DELETE SIM PLAN',
                            description: "This action cannot be undone.",
                            name: plan.name,
                            type: 'information',
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                            {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();
                        modal.close.then((result2: Object) => {
                            modalElem.hide();
                            if (result2)
                                self.deleteSimPlan(plan);
                        });
                    });
                }
            });
        }

        public idFromHref(simPlanHref: string): number {
            return Common.Utils.idFromHref(simPlanHref);
        }

        private initData(): void {
            this.selectize = undefined;
            this.paginationPage = 0;
            this.paginationSize = -1;
            this.loadSimPlans();
        }

        private loadSimPlans(): void {
            this.simPlanService.getAllPaginatedSimPlans(
                (simPlans: IPaginatedList<SimPlan>) => {
                    this.simPlans = simPlans;
                }, this.paginationPage, this.paginationSize, "name"
            );
        }

        private saveSimPlan(simPlan: SimPlan): void {
            this.simPlanService.saveSimPlan(simPlan)
                .then(() => {
                        this.changePageNumber(this.simPlans.page.totalPages - 1);
                    })
                .catch(() => {
                    this.messageTranslationsService.alertOnError("Something was wrong creating/updating the plan");
                });
        }

        private deleteSimPlan(simPlan: SimPlan): void {
            this.simPlanService
                .deleteSimPlan(simPlan)
                .then(() => {
                    this.changePageNumber(0);
                });
        }

        private loadSelectize(): void {
            if (this.selectize !== undefined)
                this.selectize.destroy();
            let $select: JQuery = $('#select-page-size').selectize({
                labelField: 'text',
                valueField: 'value',
                maxItems: 1,
                onChange: (paginationSize: number): void => {
                    let firstTime: boolean = this.paginationSize === -1;
                    this.paginationSize = paginationSize;
                    this.paginationPage = 0;
                    if (!firstTime) this.loadSimPlans();
                },
                options: [
                    { value: 10, text: '10 elements per page'},
                    { value: 20, text: '20 elements per page'},
                    { value: 50, text: '50 elements per page'},
                    { value: 100, text: '100 elements per page'},
                ],
            });
            this.selectize = $select[0].selectize;
            this.selectize.setValue(10);
        }
    }
}